import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@core/base.component';
import {
	MatterMortgageType,
	MatterMortgageWithAssociations,
	TransactionType,
} from '@models/mortgage';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { NavigationService } from '@services/nav/nav.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { BUTTON_PRESETS } from 'src/app/ui/button/button.component';

interface MortgageTab {
	id: string;
	relatedMortgageId: string;
	type: MatterMortgageType;
	transactionType: TransactionType;
	description: string;
	logoUrl?: string;
}

interface VM {
	mortgages: MatterMortgageWithAssociations[];
	selectedMortgageIndex: number;
}

const defaultVM: VM = {
	mortgages: null,
	selectedMortgageIndex: null,
};

@UntilDestroy()
@Component({
	selector: 'app-charges',
	templateUrl: './charges.component.html',
	styleUrls: ['./charges.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChargesComponent extends BaseComponent<VM> implements OnInit {
	public BUTTON_PRESETS = BUTTON_PRESETS;
	public teraviewLink =
		'https://www.teraviewereg.ca/TvApp/Login.jsp?language=en';

	public baseUrl: string;
	public mortgageOptions: MortgageTab[] = [];
	@SelectSnapshot(MatterMortgagesState.getAllMortgagesWithAssociations)
	mortgages: MatterMortgageWithAssociations[];
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
	) {
		super(defaultVM);
	}

	public ngOnInit(): void {
		this.baseUrl = UrlService.Matter_Closing_Charges(this.matterId);

		const isOnChildRoute =
			this.route.firstChild?.snapshot.paramMap.has('mortgageId');

		if (!isOnChildRoute) {
			this.redirectToCharge(this.mortgages[0].id);
		}
	}

	public redirectToCharge(mortgageId: string) {
		this.router.navigate([mortgageId], { relativeTo: this.route });
	}

	public goToMortgages() {
		this.navigationService.goToMatter_Mortgages(this.matterId);
	}
}
